import React from 'react';
import logo from '../../../../../images/modules/Revue-logo.svg';
import './index.scss';

export const Footer = () => {
    return (
        <div className='revue-footer'>
            <div className='revue-footer__top'>
                <div className='revue-footer__logo'>
                    <img src={logo} alt='logo' />
                </div>
                <div className='revue-footer__text'>
                    The latest fashion news, beauty coverage, celebrity style, fashion week updates, culture reviews,
                    and videos
                </div>
            </div>
            <div className='revue-footer__divider' />
            <div className='revue-footer__links'>
                <div className='revue-footer__link'>User Agreement</div>
                <div className='revue-footer__link'>Privacy Policy</div>
                <div className='revue-footer__link'>Accessibility Help</div>
                <div className='revue-footer__link'>Masthead</div>
                <div className='revue-footer__link'>Visual Stories</div>
            </div>
        </div>
    );
};
